import Sidebar from "./SideBar.vue";
import SidebarItem from "./SidebarItem.vue";
import SidebarGroupItem from "./SidebarGroupItem.vue";
import Cookies from "js-cookie";

const SidebarStore = {
  showSidebar: false,
  isMobie: false,
  pinSidebar: Cookies.get("sidebarStatus")
    ? !!+Cookies.get("sidebarStatus")
    : true,
  sidebarLinks: [],
  isMinimized: false,
  displaySidebar(value) {
    this.showSidebar = value;
  },
  outsideClick() {
    if (this.isMobie) {
      if (this.pinSidebar) {
        this.pinSidebar = false;
      }
    }
  },
  displaySidebarMobie(value) {
    setTimeout(() => {
      this.pinSidebar = value;
      this.isMobie = true;
    }, 1);
  },
  doPinSidebar(value) {
    this.isMobie = false;
    this.pinSidebar = value;
    if (value) {
      Cookies.set("sidebarStatus", 1);
    } else {
      Cookies.set("sidebarStatus", 0);
    }
  }
  //,
  // toggleMinimize() {
  //   document.body.classList.toggle("sidebar-mini");
  //   // we simulate the window Resize so the charts will get updated in realtime.
  //   const simulateWindowResize = setInterval(() => {
  //     window.dispatchEvent(new Event("resize"));
  //   }, 200);

  //   // we stop the simulation of Window Resize after the animations are completed
  //   setTimeout(() => {
  //     clearInterval(simulateWindowResize);
  //   }, 1000);

  //   this.isMinimized = !this.isMinimized;
  // }
};

const SidebarPlugin = {
  install(Vue, options) {
    if (options && options.sidebarLinks) {
      SidebarStore.sidebarLinks = options.sidebarLinks;
    }
    let app = new Vue({
      data: {
        sidebarStore: SidebarStore
      }
    });
    Vue.prototype.$sidebar = app.sidebarStore;
    Vue.component("side-bar", Sidebar);
    Vue.component("sidebar-item", SidebarItem);
    Vue.component("sidebar-group-item", SidebarGroupItem);
  }
};

export default SidebarPlugin;
